import { render } from "./cpt-combination-page-base.vue?vue&type=template&id=082225f8"
import script from "./cpt-combination-page-base.vue?vue&type=script&lang=js"
export * from "./cpt-combination-page-base.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__